import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideFirebaseApp, initializeApp, getApp } from '@angular/fire/app';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { provideAuth, getAuth, initializeAuth, indexedDBLocalPersistence } from '@angular/fire/auth';
import { environment } from '@environments/environment';
import { getStorage, provideStorage } from '@angular/fire/storage';
import { MenuComponent } from './menu/menu.component';
import { getMessaging, provideMessaging } from '@angular/fire/messaging';
import { AuthInterceptor } from '@interceptors/auth.interceptor';
import { Capacitor } from '@capacitor/core';

@NgModule({
    declarations: [MenuComponent],
    imports: [SharedModule],
    exports: [MenuComponent],
    providers: [
        provideHttpClient(withInterceptorsFromDi()),
        provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
        provideFirestore(() => getFirestore()),
        provideAuth(() =>
            Capacitor.isNativePlatform() ? initializeAuth(getApp(), { persistence: indexedDBLocalPersistence }) : getAuth()
        ),
        provideStorage(() => getStorage()),
        provideMessaging(() => getMessaging()),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        }
    ]
})
export class CoreModule {}
